<template>
  <v-layout row pa-3>
    <v-fab-transition>
      <v-btn color="pink" dark fixed bottom right fab @click="createItem">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-flex xs12>
      <v-alert :value="noData" dismissible color="error" icon="warning" outlined
        >We can't find a service. Please use service id or service
        code.</v-alert
      >
      <v-card>
        <v-toolbar text>
          <v-icon>local_shipping</v-icon>
          <v-toolbar-title
            >Services ({{ items.length || 0 }} total)</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchQuery"
            v-on:keyup.enter="search(searchQuery)"
          ></v-text-field>
          <v-btn icon @click.stop="search(searchQuery)">
            <v-icon>search</v-icon>
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          :must-sort="true"
          hide-default-footer
          class="mt-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <a @click.stop="updateItem(props.item)">{{
                  props.item.name
                }}</a>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.group }}</td>
              <td>{{ props.item.created | moment("YYYY-DD-MM") }}</td>
              <td>
                <v-btn icon @click.stop="updateItem(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon @click.stop="removeItem(props.item.id)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>No data</template>
        </v-data-table>
        <v-footer class="pt-5"></v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import fb from "@/firebase";
import { mapMutations } from "vuex";

import ServiceForm from "@/components/ServiceForm";

const services = fb.db.collection("service_profiles").orderBy("name");

export default {
  components: {},
  data: () => ({
    items: [],
    newItemName: "",
    currentItem: {},
    searchQuery: "",
    noData: false,
    headers: [
      { text: "Name", value: "name" },
      { text: "Code", value: "code", sortable: false },
      { text: "Group", value: "group", sortable: false },
      { text: "Created", value: "created" },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    total: 0
  }),
  firestore: {
    items: services
  },
  methods: {
    ...mapMutations(["setAppAlert"]),
    createItem: function() {
      const voidService = {};
      this.$modal.show(
        ServiceForm,
        {
          service: voidService
        },
        {
          height: "auto",
          scrollable: true
        }
      );
    },
    removeItem: function(id) {
      if (id) {
        if (confirm("Are you sure ?")) {
          services.doc(id).delete();
          this.setAppAlert({
            visible: true,
            text: "The service has been removed",
            color: "success"
          });
        }
      }
    },
    updateItem: function(item) {
      this.currentItem = Object.assign({}, item);
      this.currentItem.id = item.id;
      this.$modal.show(
        ServiceForm,
        {
          service: this.currentItem
        },
        {
          height: "auto",
          scrollable: true
        }
      );
    },
    search: function(query) {
      this.noData = false;
      if (query && query.length >= 5) {
        fb.db
          .collection("service_profiles")
          .where("code", "==", query)
          .get()
          .then(snapshot => {
            if (!snapshot.empty) {
              snapshot.forEach(doc => {
                this.itemFound = doc.data();
                this.itemFound.id = doc.id;
              });
              this.items = [this.itemFound];
            } else {
              fb.db
                .collection("service_profiles")
                .doc(query)
                .get()
                .then(doc => {
                  if (doc.data()) {
                    this.itemFound = doc.data();
                    this.itemFound.id = doc.id;
                    this.items = [this.itemFound];
                  } else {
                    this.noData = true;
                  }
                })
                .catch(() => {
                  this.noData = true;
                });
            }
          });
      } else {
        this.$bind(
          "items",
          fb.db.collection("service_profiles").orderBy("name")
        );
      }
    }
  }
};
</script>
